import { jsx as _jsx } from "react/jsx-runtime";
const variantClass = {
    cta: 'btn-cta w-full font-bold py-4 text-[15px] tracking-wide flex items-center justify-center gap-2',
    sec: 'btn-sec w-full font-medium py-3.5 text-[14px] tracking-wide',
    back: 'btn-back',
    ghost: 'btn-ghost text-[14px]',
};
export function Button({ variant = 'cta', children, className = '', ...props }) {
    return (_jsx("button", { className: `${variantClass[variant]} ${className}`, ...props, children: children }));
}
